import { Injectable } from '@angular/core';
import {BaseService} from "./BaseService";

@Injectable({
  providedIn: 'root'
})
export class SpinnerService extends BaseService {

  get showSpinner(): boolean {
    return this._showSpinner;
  }

  set showSpinner(value: boolean) {
    this._showSpinner = value;
  }

  get activeHTTPRequests(): number {
    return this._activeHTTPRequests;
  }

  private set activeHTTPRequests(value: number) {
    this._activeHTTPRequests = value;
    if (this._activeHTTPRequests > 0) {
      setTimeout(() => {
        if (this._activeHTTPRequests > 0) {
          this.showSpinner = true;
        }
      }, 0)
    } else if (this._activeHTTPRequests === 0) {
      setTimeout(() => {
        if (this._activeHTTPRequests === 0) {
          this.showSpinner = false;
        }
      }, 0);
    }
  }

  private _activeHTTPRequests: number;
  private _showSpinner: boolean;

  constructor() {
    super();
    this._activeHTTPRequests = 0;
    this._showSpinner = false;
  }


  override cleanupServiceFields(): void {
    this._activeHTTPRequests = 0;
    this._showSpinner = false;
  }

  public addHTTPRequest(): void {
    this.activeHTTPRequests++;
  }

  public removeHTTPRequest(): void {
    if (this.activeHTTPRequests) this.activeHTTPRequests--;
  }

}
